import { NotificationPreference, INotificationPreference } from "./NotificationPreference";
import { AlertCategories, AlertLevels, AlertType } from '../alert/Types';

export class NotificationEventSettings implements INotificationEventSettings {
    card?:INotificationPreference = null;
    push?:INotificationPreference = null;
    email?:INotificationPreference = null;
    sms?:INotificationPreference = null;

    byCategory?:Partial<{ [key in AlertCategories]: INotificationEventSettings }> = null;
    byLevel?:Partial<{ [key in AlertLevels]: INotificationEventSettings }> = null;
    byType?:Partial<{ [key in string]: INotificationEventSettings }> = null;
    bySite?:Partial<{ [key in string]: INotificationEventSettings }> = null;
    byDevice?:Partial<{ [key in string]: INotificationEventSettings }> = null;

    public constructor(init?:Partial<NotificationEventSettings>) {
        if (init?.card)
            this.card = new NotificationPreference(Object.assign({ delay: 0 }, init.card));
        if (init?.push)
            this.push = new NotificationPreference(Object.assign({ delay: 0 }, init.push));
        if (init?.email)
            this.email = new NotificationPreference(Object.assign({ delay: 0 }, init.email));
        if (init?.sms)
            this.sms = new NotificationPreference(Object.assign({ delay: 0 }, init.sms));

        if (init?.byCategory) {
            this.byCategory = {};
            for (let key in init.byCategory) {
                this.byCategory[key] = new NotificationEventSettings(init.byCategory[key]);
            }
        }
        if (init?.byLevel) {
            this.byLevel = {};
            for (let key in init.byLevel) {
                this.byLevel[key] = new NotificationEventSettings(init.byLevel[key]);
            }
        }
        if (init?.byType) {
            this.byType = {};
            for (let key in init.byType) {
                this.byType[key] = new NotificationEventSettings(init.byType[key]);
            }
        }
        if (init?.bySite) {
            this.bySite = {};
            for (let key in init.bySite) {
                this.bySite[key] = new NotificationEventSettings(init.bySite[key]);
            }
        }
        if (init?.byDevice) {
            this.byDevice = {};
            for (let key in init.byDevice) {
                this.byDevice[key] = new NotificationEventSettings(init.byDevice[key]);
            }
        }
    }
}

export interface INotificationEventSettings {
    byCategory?:Partial<{ [key in AlertCategories]: INotificationEventSettings }>;
    byLevel?:Partial<{ [key in AlertLevels]: INotificationEventSettings }>;
    byType?:Partial<{ [key in string]: INotificationEventSettings }>;
    bySite?:Partial<{ [key in string]: INotificationEventSettings }>;
    byDevice?:Partial<{ [key in string]: INotificationEventSettings }>;

    card?:INotificationPreference;
    push?:INotificationPreference;
    email?:INotificationPreference;
    sms?:INotificationPreference;
}